import { getConfig } from '@local/app-config';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {
    clearCombinedToken as clearAccessToken,
    getCombinedToken as getAccessToken,
} from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';

// We fetch this at run time to make testing easier, we can override the env values.
const entitlementBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    args,
    WebApi,
    extraOptions,
) => {
    const baseUrl = getConfig().entitlements_url;
    const rawBaseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            const token = getAccessToken()?.access_token;
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            } else {
                clearAccessToken();
            }
            return headers;
        },
    });
    const result = await rawBaseQuery(args, WebApi, extraOptions);
    if (result.error && result.error.status === 401) {
        clearAccessToken();
    }
    return result;
};

export const EntitlementsApiClient = createApi({
    reducerPath: 'entitlementsAPI',
    baseQuery: entitlementBaseQuery,
    endpoints: () => ({}),
});
